import { ReactElement, useEffect } from 'react'
import {
  PageWrapper,
  SectionTitle,
  FlexWrapper,
  Column,
  BackButton
} from '../../../../components'
import { useHistory } from 'react-router-dom'
import strings from '../../../../locale/en'
import { CardWrapper } from '../subcomponents'
import { shallowEqual, useSelector, useDispatch } from 'react-redux'
import { RootState } from '../../../../redux/store'
import { setSelectedBatch } from '../../../../redux/batch/action'
import { Batch } from '../../../../redux/batch/types'

const View = (): ReactElement => {
  const { selectedBatch } = useSelector(
    (state: RootState) => ({
      selectedBatch: state.batch.selectedBatch
    }),
    shallowEqual
  )
  const history = useHistory()
  const dispatch = useDispatch()

  const { coachingCentre, coachingCentreBranch, course } =
    selectedBatch as Batch

  const {
    menu: {
      batch: { viewBatch }
    },
    batchDetails: {
      batchName,
      instituteName,
      branchName,
      courseName,
      batchStartDate,
      batchEndDate,
      startTiming,
      endTiming,
      batchSize,
      description,
      status
    }
  } = strings

  useEffect(() => {
    return () => {
      dispatch(setSelectedBatch(null))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <PageWrapper id="container">
      <div>
        <BackButton
          handleBack={() => {
            history.goBack()
          }}
        />
      </div>
      <SectionTitle title={viewBatch} hasBorder />
      <FlexWrapper justifyContent="space-around">
        <CardWrapper>
          <Column keyName={batchName} value={selectedBatch?.batchName} />
          <Column
            keyName={instituteName}
            value={coachingCentre?.coachingCentreName}
          />
          <Column
            keyName={branchName}
            value={coachingCentreBranch?.branchName}
          />
          <Column keyName={courseName} value={course.courseName} />
          <Column
            keyName={batchStartDate}
            value={selectedBatch?.batchStartDate}
          />
          <Column keyName={batchEndDate} value={selectedBatch?.batchEndDate} />
        </CardWrapper>
        <CardWrapper>
          <Column keyName={startTiming} value={selectedBatch?.startTiming} />
          <Column keyName={endTiming} value={selectedBatch?.endTiming} />
          <Column keyName={batchSize} value={selectedBatch?.batchSize} />
          <Column keyName={description} value={selectedBatch?.description} />
          <Column keyName={status} value={selectedBatch?.status} />
        </CardWrapper>
      </FlexWrapper>
    </PageWrapper>
  )
}

export default View
